import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "@playbookai/api-clients";
import { kpiApi } from "../api/live-client.js";
import type { KpiDefinition } from "../api/types.js";
import { kpiKeys } from "./kpiQueryKeys.js";

/**
 * The browsable KPI Type catalog (`GET /v1/kpi-definitions`) — the create flow's
 * Type picker. Types are system-provided and rarely change, so this caches
 * longer than the KPI lists.
 */
export function useKpiDefinitions() {
  const config = useApiClient();
  return useQuery<KpiDefinition[]>({
    queryKey: kpiKeys.definitions(),
    queryFn: () => kpiApi.listDefinitions(config),
    staleTime: 5 * 60_000,
  });
}
